import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Card } from '../../helpers/Card';
import { Form } from './Form';

import style from './style.module.css';

/**
 * Foot section component: approval dates, online links and approval statistics.
 *
 * @param {object} props
 * @param {Immutable.Map} props.common General information.
 * @param {Function} props.onChange Handle date change.
 * @param {Function} props.onSaveDates Save the dates on blur.
 * @param {boolean} props.isNoApproval No approval list selected state.
 */
const FootSectionComponent = ({ common, onChange, onSaveDates, isNoApproval }) => (
  <Card className={style.host}>
    <Form common={common} isNoApproval={isNoApproval} onChange={onChange} onSubmit={onSaveDates} />
  </Card>
);

FootSectionComponent.propTypes = {
  common: PropTypes.instanceOf(Map).isRequired,
  isNoApproval: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSaveDates: PropTypes.func,
};

/** Foot section component. */
export const FootSection = memo(FootSectionComponent);
